import React from 'react';
import {GeneratedVideoChunk} from '../../../data/models/LibraryFile/GeneratedVideoChunk';
import styles from './ChunkPreview.module.css';
import {VideoEditorText} from '../VideoEditorText';

interface Props {
  selectedChunk?: GeneratedVideoChunk;
  onPlayFinished?: () => void;
}

const ChunkPreview: React.FC<Props> = ({selectedChunk, onPlayFinished}) => {
  return selectedChunk ? (
    <div className={styles.chunksPreviewContainer}>
      {/* <SimplePlayerControlled
        source={selectedChunk.uri}
        onFinished={onPlayFinished}
        width={0}
      /> */}
      <video
        src={selectedChunk.uri}
        controls
        onEnded={onPlayFinished}
        className={styles.videoPlayer}
      />
    </div>
  ) : (
    <div className={styles.empty}>
      <p>{VideoEditorText.emptyChunkPreview}</p>
    </div>
  );
};

export default React.memo(ChunkPreview);
